/**
 * Snack notifications priorities - we will use these values to sort them
 * @type {number}
 */
export const HIGH_PRIORITY = 0;
export const MEDIUM_PRIORITY = 1;
export const LOW_PRIORITY = 2;


export const CART = {
    priority: HIGH_PRIORITY,
    id: 0,
    type: 'cart',
    delay: 4000,
};



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/constants/snackbar-notifications.js